import { datadogRum } from '@datadog/browser-rum'

/**
 * Normalized segment fields for Datadog facets (@context.location_id, etc.).
 */
export function buildBookingSegmentContext({ locationId, providerId, partnerId }) {
  const ctx = {}
  if (locationId != null && locationId !== '') {
    ctx.location_id = locationId
  }
  if (providerId != null && providerId !== '') {
    ctx.provider_id = providerId
  }
  if (partnerId != null && partnerId !== '') {
    ctx.partner_id = partnerId
  }
  return ctx
}

/**
 * True when the RUM SDK has been initialized. Prefer `getInitConfiguration()` (public API);
 * `getInternalContext()` can be unset briefly after init (e.g. iframe / session timing) which
 * would skip manual `startView` while `trackViewsManually` is enabled.
 */
export function isRumReady() {
  if (typeof datadogRum.getInitConfiguration === 'function') {
    const cfg = datadogRum.getInitConfiguration()
    if (cfg != null) {
      return true
    }
  }
  return (
    typeof datadogRum.getInternalContext === 'function' &&
    Boolean(datadogRum.getInternalContext())
  )
}

/**
 * Merges booking URL segment into RUM global context so actions, errors, and resources inherit it.
 */
export function applyBookingSegmentToRum(segment) {
  if (!isRumReady()) {
    return
  }
  const existing =
    typeof datadogRum.getGlobalContext === 'function'
      ? datadogRum.getGlobalContext()
      : {}
  datadogRum.setGlobalContext({
    ...existing,
    ...segment,
  })
}

/**
 * Starts a named RUM view with optional view-level context (merged with global context in the event).
 */
export function startBookingRumView(viewName, segment) {
  if (!isRumReady()) {
    return
  }
  const hasContext = segment && Object.keys(segment).length > 0
  datadogRum.startView({
    name: viewName,
    ...(hasContext ? { context: segment } : {}),
  })
}
